const B = "https://cdn.prod.website-files.com/5e95b7d352d2e8c65a55a3b9/";

export const CARD_SUITS = {
  diamonds: [
    { name: "Ace of Diamonds", url: `${B}65cc93c32afa8fe13eac92fd_A%20diamond.jpg` },
    { name: "2 of Diamonds", url: `${B}65cc93c346f50d72ae8e0c2b_2%20diamond.jpg` },
    { name: "3 of Diamonds", url: `${B}65cc93c3927713da7471214e_3%20diamond.jpg` },
    { name: "4 of Diamonds", url: `${B}65cc93c52512d0a2d979e2c8_4%20diamond.jpg` },
    { name: "5 of Diamonds", url: `${B}65cc93c3b7d6f1cef3c7556e_5%20diamond.jpg` },
    { name: "6 of Diamonds", url: `${B}65cc93c346f50d72ae8e0c31_6%20diamond.jpg` },
    { name: "7 of Diamonds", url: `${B}65cc93c342d58de33d6adb51_7%20diamond.jpg` },
    { name: "8 of Diamonds", url: `${B}65cc93c3b8c0d5d11e870e05_8%20diamond.jpg` },
    { name: "9 of Diamonds", url: `${B}65cc93c6b8ec74c43d82a30c_9%20diamond.jpg` },
    { name: "10 of Diamonds", url: `${B}65cc93c3ff9ceca1fb59dca1_10%20diamond.jpg` },
  ],
  hearts: [
    { name: "Ace of Hearts", url: `${B}65cd02ffceed6ae8e6262ddd_A%20heart.jpg` },
    { name: "2 of Hearts", url: `${B}65cd0300958ec759a500f57e_2%20heart.jpg` },
    { name: "3 of Hearts", url: `${B}65cd0300a8a10d3606fc0d50_3%20heart.jpg` },
    { name: "4 of Hearts", url: `${B}65cd030078c499b46c3b91d7_4%20heart.jpg` },
    { name: "5 of Hearts", url: `${B}65cd0300febad35d7c575b46_5%20heart.jpg` },
    { name: "6 of Hearts", url: `${B}65cd03008edd9c8fc034d85b_6%20heart.jpg` },
    { name: "7 of Hearts", url: `${B}65cd03001fed3a3cba44c8c9_7%20heart.jpg` },
    { name: "8 of Hearts", url: `${B}65cd0300a42f14b51c54ff3a_8%20heart.jpg` },
    { name: "9 of Hearts", url: `${B}65cd030078e5e53f9d0a11dc_9%20heart.jpg` },
    { name: "10 of Hearts", url: `${B}65cd030075f15d0e4ef7ecb6_10%20heart.jpg` },
  ],
  spades: [
    { name: "Ace of Spades", url: `${B}65cd03b78284f32e346a6e79_A%20spade.jpg` },
    { name: "2 of Spades", url: `${B}65cd03b7076f6f0db3841afd_2%20spade.jpg` },
    { name: "3 of Spades", url: `${B}65cd03b89bfea9513f3bcaa6_3%20spade.jpg` },
    { name: "4 of Spades", url: `${B}65cd03b77148a5e94104959b_4%20spade.jpg` },
    { name: "5 of Spades", url: `${B}65cd03b70bb1abaa472b1c74_5%20spade.jpg` },
    { name: "6 of Spades", url: `${B}65cd03b736313389d5474191_6%20spade.jpg` },
    { name: "7 of Spades", url: `${B}65cd03b7edad5c979bda8a7e_7%20spade.jpg` },
    { name: "8 of Spades", url: `${B}65cd03b8ec5a15809dbc1359_8%20spade.jpg` },
    { name: "9 of Spades", url: `${B}65cd03b7c0730963cdfa1646_9%20spade.jpg` },
    { name: "10 of Spades", url: `${B}65cd03b76f747387701cbaa6_10%20spade.jpg` },
  ],
  clubs: [
    { name: "Ace of Clubs", url: `${B}65cd04856286d65c8f9ba1b8_A%20clubs.jpg` },
    { name: "2 of Clubs", url: `${B}65cd04858af7edd7971c0d79_2%20clubs.jpg` },
    { name: "3 of Clubs", url: `${B}65cd0485e9a20fc358bb9841_3%20clubs.jpg` },
    { name: "4 of Clubs", url: `${B}65cd04857eff46d3b1d8b92b_4%20clubs.jpg` },
    { name: "5 of Clubs", url: `${B}65cd04858c7b74f8f6aa5de9_5%20clubs.jpg` },
    { name: "6 of Clubs", url: `${B}65cd0485136a39a1e9721d1c_6%20clubs.jpg` },
    { name: "7 of Clubs", url: `${B}65cd048547449e818eef1a19_7%20clubs.jpg` },
    { name: "8 of Clubs", url: `${B}65cd0485cdd1c25ec42ea1aa_8%20clubs.jpg` },
    { name: "9 of Clubs", url: `${B}65cd0485caeb8b580fd0dfd7_9%20clubs.jpg` },
    { name: "10 of Clubs", url: `${B}65cd0485e9a20fc358bb985e_10%20clubs.jpg` },
  ],
};

export const FACE_CARDS = [
  { name: "Jack of Diamonds", url: `${B}65cd05476dfde65f950a38eb_J%20diamond.jpg` },
  { name: "Jack of Hearts", url: `${B}65cd054758ac712906a05f74_J%20heart.jpg` },
  { name: "Jack of Spades", url: `${B}65cd05474ea4afac7e722825_J%20spade.jpg` },
  { name: "Jack of Clubs", url: `${B}65cd054772bb8d7c870df8ac_J%20clubs.jpg` },
  { name: "Queen of Diamonds", url: `${B}65cd05476f3823b53ca58686_Q%20diamond.jpg` },
  { name: "Queen of Hearts", url: `${B}65cd054887a0369e9dc5dca5_Q%20heart.jpg` },
  { name: "Queen of Spades", url: `${B}65cd05484480c031ac5e4d9c_Q%20spade.jpg` },
  { name: "Queen of Clubs", url: `${B}65cd05476dfde65f950a3900_Q%20clubs.jpg` },
  { name: "King of Diamonds", url: `${B}65cd0547f98efff420f7693c_K%20diamond.jpg` },
  { name: "King of Hearts", url: `${B}65cd0547b4283abd8ea6276c_K%20heart.jpg` },
  { name: "King of Spades", url: `${B}65cd0547b4283abd8ea6278b_K%20spade.jpg` },
  { name: "King of Clubs", url: `${B}65cd05471de3a9b535b8de8f_K%20clubs.jpg` },
];

export const JOKERS = [
  { name: "Joker I", url: `${B}65cd0547a7425e9854fd9ac9_Joker%206.jpg` },
  { name: "Joker II", url: `${B}65cd0547e8fd18d558ce4f65_Joker%207.jpg` },
];

export const FEATURED_CARDS = [
  CARD_SUITS.diamonds[0],
  CARD_SUITS.hearts[4],
  CARD_SUITS.spades[2],
  CARD_SUITS.clubs[6],
  FACE_CARDS[4],
  FACE_CARDS[9],
  JOKERS[0],
  CARD_SUITS.diamonds[7],
  CARD_SUITS.hearts[1],
  CARD_SUITS.spades[8],
  FACE_CARDS[2],
  FACE_CARDS[11],
];
